<template>
<div>
        <div :class="classModal">
            
		</div>
        <div v-if="open">
            <div class="patiente"> Veuillez patienter ...</div>
            <div>
                  <div id="waiting"></div> 
                  <div id="waiting"></div> 
                   <div id="waiting"></div> 
            </div>
        </div>
</div>
</template>
<style scoped>
    .patiente {
        top: 10%;
        position: fixed;
        font-size: 40px;
        left: 20%;
        z-index: 1200;
        color: white;
    }
    .smodal {
        width: 200%;
        height: 200%;
        position: fixed;
        top: 0px;
        left: 0px;
        visibility: hidden;
        background-color: white;
        z-index: 1000;
    }
     .smodalactive {
        width: 200%;
        height: 200%;
        position: fixed;
        top: 0px;
        left: 0px;
        opacity: 1;
        background-color: #a3a8c4;
        z-index: 1000;
        visibility: visible;
    }

        div#waiting {
            z-index: 1200;
            width: 100px;
            height: 100px;
            position: fixed;
            
            top: 30%;
            left: 0%;
            border-radius: 50%;
            opacity: 1;
            background-image: url('../assets/boule.png');
            background-size: contain;
            background-repeat: none;
        }

        div#waiting:nth-child(1) {
            animation: move 3s infinite cubic-bezier(.2,.64,.81,.23);
           
        }
        div#waiting:nth-child(2) {
            animation: move 4s infinite cubic-bezier(.2,.64,.81,.23);
            top: 50%;
        }
       div#waiting:nth-child(3) {
            animation: move 5s infinite cubic-bezier(.2,.64,.81,.23);
            top: 70%;
        }


        @keyframes move {
            from {-webkit-transform:rotate(0deg); left:0%;} to {-webkit-transform:rotate(360deg); left:120%;}
        }
            
        @-webkit-keyframes move{ 
         from {-webkit-transform:rotate(0deg); left:0%;} to {-webkit-transform:rotate(360deg); left:120%;}
        } 
        @-moz-keyframes move{ 
         from {-webkit-transform:rotate(0deg); left:0%;} to {-webkit-transform:rotate(360deg); left:120%;}
        } 
        @-o-keyframes move{ 
         from {-webkit-transform:rotate(0deg); left:0%;} to {-webkit-transform:rotate(360deg); left:120%;}
        } 

   
</style>
<script>
export default {
    props:["open"],
    data() {
			return {
				classModal: "smodal"
			}
		},
    watch: {
        open: function(val) {
            
            if (val)
                this.classModal = "smodalactive";
            else
                this.classModal = "smodal";
        }
    },
}
</script>